const MAX_VISIBLE_JOB_FEEDBACK_COUNT = 10;
const MAX_BULK_TICKET_CHANGE_SELECTION_LIMIT = 20;

const BULK_TICKET_CHANGE_JOB_START_EVENT = 'BULK_TICKET_CHANGE_JOB_START_EVENT';
const BULK_TICKET_CHANGE_JOB_FINISH_EVENT = 'BULK_TICKET_CHANGE_JOB_FINISH_EVENT';
const ALL_BULK_TICKET_CHANGE_JOB_FINISHED_EVENT = 'ALL_BULK_TICKET_CHANGE_JOB_FINISHED_EVENT';

export {
    ALL_BULK_TICKET_CHANGE_JOB_FINISHED_EVENT,
    BULK_TICKET_CHANGE_JOB_FINISH_EVENT,
    BULK_TICKET_CHANGE_JOB_START_EVENT,
    MAX_BULK_TICKET_CHANGE_SELECTION_LIMIT,
    MAX_VISIBLE_JOB_FEEDBACK_COUNT
};
